<template>
  <el-table
    :data="invoices"
    stripe
  >
    <el-table-column
      label="Account"
      prop="account"
      width="300px"
      show-overflow-tooltip
      :formatter="(row, col, cellValue) => cellValue ? cellValue.name : '-'"
    />
    <el-table-column
      label="Invoice Number"
      prop="invoice_account_counter"
    />
    <el-table-column
      label="Parent Invoice"
      prop="parent"
      :formatter="(row, col, cellValue) => cellValue ? row.parent.invoice_account_counter : '-'"
    />
    <el-table-column
      label="Invoice Date"
      prop="invoice_date"
    />
    <el-table-column
      label="Invoice Amount"
      prop="buy_rate"
    />
    <el-table-column
      label="Invoice Amount Inc GST"
      prop="buy_rate"
    />
    <el-table-column
      label="Actions"
      align="right"
    >
      <template
        slot-scope="scope"
      >
        <el-dropdown
          split-button
          size="mini"
          @command="handleActionCommand"
          @click="resendEmail(scope.$index)"
        >
          Resend Email
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="{ action: downloadCSV, scope}">
              Download CSV
            </el-dropdown-item>
            <el-dropdown-item
              divided
              :command="{ action: downloadPDF, scope}"
            >
              Download PDF
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    invoices: {
      type: Array,
      required: true
    }
  },
  methods: {
    handleActionCommand ({ action, scope }) {
      action(scope)
    },
    downloadCSV (scope) {
      //
    },
    downloadPDF (scope) {
      //
    },
    resendEmail (index) {
      //
    }
  }
}
</script>
